<rs-modal #modal (show)="show()" [config]="modalConfig" (cancel)="cancel()">
  @if (config) {
    <div>
      <div class="main-title-section">
        <h2 class="title">{{ config.title | translate }}</h2>
      </div>
      @for (group of config.groups; track group) {
        <div>
          <div class="group-title-section">
            <h4>{{ group.title | translate }}</h4>
          </div>
          @for (paragraph of group.paragraphs; track paragraph) {
            <div>
              <p>{{ paragraph.value | translate }}</p>
            </div>
          }
          @for (subsection of group.subsections; track subsection) {
            <div>
              <div class="subtitle-section">
                <h5>{{ subsection.title | translate }}</h5>
              </div>
              @for (subParagraph of subsection.paragraphs; track subParagraph) {
                <div>
                  <p>{{ subParagraph.value | translate }}</p>
                </div>
              }
            </div>
          }
          <hr>
          </div>
        }
      </div>
    }
  </rs-modal>
